import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'projects/lib_authentication/src/public-api';
import { CustomNotificationService } from 'projects/lib_util/src/public-api';

@Component({
    selector: 'spv2-no-access',
    templateUrl: './no-access.component.html',
    styleUrls: ['./no-access.component.scss'],
    standalone: false
})
export class NoAccessComponent implements OnInit {

  constructor(private authService: AuthenticationService, private notificationService: CustomNotificationService) { }

  ngOnInit(): void {
  }

  requestAccess() {
    this.authService.requestAccessToPortal().subscribe(() => {
      this.notificationService.info("Access has been requested. You will be able to access the tool as soon as an administrator approves your request.");
    });
  }
}
